var _linearGradient, _circle, _circle2, _path, _circle3, _path2, _path3, _path4, _circle4, _g, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 698,
    viewBox: "0 0 698 698",
    width: 698,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 349,
    x2: 349,
    y1: 698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 349,
    fill: "url(#a)",
    opacity: 0.5,
    r: 349
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.68,
    cy: 346.77,
    fill: "#f5f5f5",
    r: 341.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m601 790.76a340 340 0 0 0 187.79-56.2c-12.59-68.8-60.5-72.72-60.5-72.72h-264.2s-45.21 3.71-59.33 67a340.07 340.07 0 0 0 196.24 61.92z",
    fill: "#6c63ff",
    transform: "translate(-251 -101)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.37,
    cy: 339.57,
    fill: "#333",
    r: 164.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m293.15 476.92h105.66a0 0 0 0 1 0 0v84.53a52.83 52.83 0 0 1 -52.81 52.83 52.83 52.83 0 0 1 -52.83-52.83v-84.53a0 0 0 0 1 0 0z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m296.5 473h99a3.35 3.35 0 0 1 3.35 3.35v81.18a52.83 52.83 0 0 1 -52.85 52.84 52.83 52.83 0 0 1 -52.83-52.83v-81.19a3.35 3.35 0 0 1 3.33-3.35z",
    fill: "#fdb797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m544.34 617.82a152.07 152.07 0 0 0 105.66.29v-13h-105.66z",
    opacity: 0.1,
    transform: "translate(-251 -101)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.37,
    cy: 372.44,
    fill: "#fdb797",
    r: 151.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-251 -101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m489.49 335.68s63.83 129.56 243.88 54.32l-41.92-65.73-74.31-26.67z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.49 333.78s63.83 129.56 243.88 54.3l-41.92-65.73-74.31-26.67z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.93 325a87.49 87.49 0 0 1 21.69-35.27c29.79-29.45 78.63-35.66 103.68-69.24 6 9.32 1.36 23.65-9 27.65 24-.16 51.81-2.26 65.38-22a44.89 44.89 0 0 1 -7.57 47.4c21.27 1 44 15.4 45.34 36.65.92 14.16-8 27.56-19.59 35.68s-25.71 11.85-39.56 14.9c-40.44 8.93-186.76 46.3-160.37-35.77z",
    fill: "#333"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.86,
    cy: 372.3,
    fill: "#fdb797",
    rx: 14.09,
    ry: 26.42
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 497.8,
    cy: 372.3,
    fill: "#fdb797",
    rx: 14.09,
    ry: 26.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profile-pic.743d9e285c8b72944a5934a202794a7b.svg";
export { ForwardRef as ReactComponent };